import React, { useState, useCallback, useEffect } from "react";

import "emoji-mart/css/emoji-mart.css";
import * as SC from "./PrintCampaignCreateTeaserEditor.styled";
import { CollapsibleText } from "../../../Previews/Components";
import logger from "../../../../../utils/LoggerFrontend.js";
import { darkChannels, shortChannels } from "../../../Previews/Campaign__Create_TeaserEditor/utils";

const PrintCampaignCreateTeaserEditor = ({
  channel,
  updatePost,
  teaserText,
  teaserTextStyle = {},
  editable,
  lines = 6,
  padding = "6px 10px",
  dark,
  allowEmpty,
  isAutoGenerated = false,
  autoGeneratedText,
  showMoreButton = true,
  placeholder = "",
  selectedTextIndex = -1
}) => {
  logger.debug("CampaignCreateTeaserEditor", "called", {
    channel,
    selectedTextIndex,
    teaserText
  });

  const [teaserInputText, setTeaserInputText] = useState(
    selectedTextIndex !== -1 ? teaserText[selectedTextIndex] : teaserText
  );
  const [isChangedAnimation, setIsChangedAnimation] = useState(false);
  const isLoadingAutoGenerated = isAutoGenerated && !autoGeneratedText && !teaserText;

  useEffect(() => {
    setTeaserInputText(selectedTextIndex !== -1 ? teaserText[selectedTextIndex] : teaserText);
  }, [teaserText, selectedTextIndex, updatePost]);

  const stopIsChangedAnimation = useCallback(() => setIsChangedAnimation(false), []);

  const isShortTeaserText = shortChannels.includes(channel) || teaserInputText?.length < 50;

  return (
    <SC.TeaserEditorWrapper isChangedAnimation={isChangedAnimation} dark={dark}>
      <>
        <SC.TeaserTextWrapper
          onAnimationEnd={stopIsChangedAnimation}
          editable={editable}
          dark={dark}
          allowEmpty={allowEmpty}
          padding={padding}
          isShort={isShortTeaserText}
          isAutoGenerated={isAutoGenerated}
        >
          <CollapsibleText
            lines={lines}
            text={teaserInputText}
            textStyle={teaserTextStyle}
            showMoreButton={showMoreButton}
            placeholder={placeholder}
            isLoading={isLoadingAutoGenerated}
            isAutoGenerated={isAutoGenerated}
            isShort={shortChannels.includes(channel)}
            isDark={dark || darkChannels.includes(channel)}
          />
        </SC.TeaserTextWrapper>
      </>
    </SC.TeaserEditorWrapper>
  );
};

export default PrintCampaignCreateTeaserEditor;
